import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const codecov = defineConnector({
  identifier: "codecov",
  name: "Codecov",
  tagLine: "Code coverage reporting",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: () => "https://api\\.codecov\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a Codecov API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API token in Codecov for the organization or user account you want 3B to use.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.codecov.io/api/v2/user",
  },
});
